<template>
  <div class="clearfix">
    <a-upload
      :class="inputClass"
      ref="uploadBtn"
      :accept="acceptType"
      :fileList="fileArray"
      :listType="listType"
      :remove="handleRemove"
      :beforeUpload="beforeUpload"
      :customRequest="myUploadReauest"
      @preview="handlePreview"
      :disabled="disabled"
    >
      <div v-if="listType == 'picture-card' && fileArray.length < limitNum" :style="`width:${width}px`">
        <a-icon :type="isUploading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">{{ text }}</div>
      </div>
      <a-button v-else-if="fileArray.length < limitNum" :style="btnStyle">
        <a-icon :type="isUploading ? 'loading' : 'upload'" />选择文件
      </a-button>
    </a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { converBToMb, transformUrl } from '@/utils/util'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
export default {
  name: 'Upload',
  data() {
    return {
      isUploading: false,
      commonFolder: process.env.VUE_APP_OBS_FOLDER_NAME,
      filePath: '',
      fileArray: [],
      previewVisible: false,
      previewImage: '',
      imageType: ['png', 'jpeg', 'jpg', 'bmp', 'gif'],
    }
  },
  props: {
    fileList: {
      type: Array,
      default: () => {
        return []
      },
    },
    inputClass: {
      type: String,
      default: '',
    },
    listType: {
      type: String,
      default: 'text',
    },
    accept: {
      type: String,
      default: '',
    },
    limitNum: {
      type: Number,
      default: 9,
    },
    singleSize: {
      type: Number,
      default: 10 * 1024,
    },
    isRename: {
      type: Boolean,
      default: true,
    },
    path: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 86,
    },
    text: {
      type: String,
      default: '图片上传',
    },
    btnStyle: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    acceptType() {
      if (this.accept) {
        return this.accept
      } else if (this.listType === 'picture' || this.listType === 'picture-card') {
        return 'image/*'
      } else {
        return ''
      }
    },
  },
  watch: {
    fileList: {
      handler(newValue, oldValue) {
        let index = 0
        this.fileArray = []
        for (const url of newValue) {
          const arr = url.split('/')
          const fileName = arr[arr.length - 1]
          this.fileArray.push({
            uid: new Date().getTime() + '-' + index++,
            size: 0,
            name: fileName,
            status: 'done',
            type: 'Undeletable',
            url: transformUrl(url),
            relativeUrl: url,
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    uploadClick() {
      console.log('uploadClick')
      document.querySelector('.' + this.inputClass + ' input').click()
    },
    async handleRemove(file) {
      const _self = this
      const index = _self.fileArray.indexOf(file)
      const newFileList = _self.fileArray.slice()
      newFileList.splice(index, 1)
      _self.fileArray = newFileList
      _self.changeSuccees()
      // const obsClient = await this.authObsClient()
      // const removeUrl = file.relativeUrl
      // obsClient.deleteObject(
      //   {
      //     Bucket: process.env.VUE_APP_OBS_BUCKET,
      //     Key: removeUrl
      //   },
      //   function(err, result) {
      //     if (err) {
      //       console.log('delete Error-->' + err)
      //     } else {
      //       const index = _self.fileArray.indexOf(file)
      //       const newFileList = _self.fileArray.slice()
      //       newFileList.splice(index, 1)
      //       _self.fileArray = newFileList
      //       _self.changeSuccees()
      //     }
      //   }
      // )
    },
    beforeUpload(file, fileList) {
      this.isUploading = true
      if (this.singleSize) {
        const limitFileSize = this.singleSize * 1024
        if (file.size > limitFileSize) {
          this.$notification['error']({
            message: '文件需小于' + converBToMb(this.singleSize) + ', 您上传的文件大小为:' + converBToMb(file.size),
          })
          return false
        }
      }
      return true
    },
    async myUploadReauest(item) {
      let prePath = this.path

      if (prePath) {
        if (!prePath.startsWith('/')) prePath = '/' + prePath
        if (!prePath.endsWith('/')) prePath = prePath + '/'
      } else {
        prePath = '/'
      }
      this.filePath = this.commonFolder + prePath
      item.file.status = 'uploading'
      const _self = this
      const obsClient = await this.authObsClient()
      let fileName = item.file.name
      if (this.isRename) {
        fileName = item.file.uid
        if (item.file && item.file.name && item.file.name.indexOf('.') >= 0) {
          const splitNames = item.file.name.split('.')
          fileName = fileName + '.' + splitNames[splitNames.length - 1]
        }
      }
      const key = this.filePath + fileName
      const relativeUrl = prePath + fileName
      obsClient.putObject(
        {
          Bucket: process.env.VUE_APP_OBS_BUCKET,
          Key: key,
          SourceFile: item.file,
        },
        function (error, res) {
          _self.isUploading = false
          _self.putFileToList(item, relativeUrl, error ? 'error' : 'success')
        }
      )
    },
    putFileToList(item, relativeUrl, status) {
      const _self = this
      const original = item.file.uid + '.' + item.file.name.split('.')[1]
      const title = original
      item.file.status = 'done'
      item.file.response = {
        status: status,
      }
      if (!relativeUrl.startsWith('/')) {
        relativeUrl = '/' + relativeUrl
      }
      const fileTemp = {
        uid: item.file.uid,
        name: item.file.name,
        status: 'done',
        url: transformUrl(relativeUrl),
        relativeUrl: relativeUrl,
      }
      _self.fileArray.push(fileTemp)
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      if (item.file.response === 'error') {
        reader.onload = function (e) {
          item.onError({
            original: original,
            state: 'ERROR',
            status: 'error',
            title: title,
            url: transformUrl(relativeUrl),
          })
        }
      } else {
        item.onSuccess({
          original: original,
          state: 'SUCCESS',
          status: 'success',
          title: title,
          url: _self.filter,
        })
      }
      this.changeSuccees()
    },
    changeSuccees() {
      const files = this.getRelativeArray()
      this.$emit('uploadChange', files)
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      const extend = file.name.indexOf('.') > -1 ? file.name.split('.')[1] : ''
      if (this.imageType.indexOf(extend.toLowerCase()) > -1) {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj)
        }
        this.previewImage = file.url || file.preview
        this.previewVisible = true
      }
    },
    getRelativeArray() {
      let relativeUrls = []
      this.fileArray.forEach((element) => {
        relativeUrls = [...relativeUrls, element.relativeUrl]
      })
      return relativeUrls
    },
    async authObsClient() {
      // const result = await this.$http.get(`/oss/oss/sts`)
      const result = await this.$http.get('https://gateway.51lss.com/oss/oss/sts')
      if (result.access) {
        const sts = result
        const obsClient = new ObsClient({
          access_key_id: sts.access,
          secret_access_key: sts.secret,
          server: process.env.VUE_APP_OBS_ENDPOINT,
        })
        obsClient.util.securityToken = sts.securitytoken
        return obsClient
      } else {
        this.$notification['error']({
          message: '上传初始化失败，请刷新页面重试',
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import 'index';
</style>
